import { Component, computed, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CnfpcToastService } from './service/cnfpc-toast.service';
import { Toast } from './model/toast.model';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-cnfpc-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cnfpc-toast.component.html',
  styleUrl: './cnfpc-toast.component.scss',
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
      transition(':leave', [
        animate(
          '300ms ease-in',
          style({ opacity: 0, transform: 'translateY(-20px)' }),
        ),
      ]),
    ]),
  ],
})
export class CnfpcToastComponent {
  private toastService = inject(CnfpcToastService);

  // Toasts actuels
  toasts = this.toastService.toasts;

  // Calcule les classes Tailwind selon le type de toast
  getToastClasses(toast: Toast): string {
    const baseClasses = 'flex items-center p-4 rounded-lg shadow-lg text-sm';

    const typeClasses = {
      success: 'bg-green-100 text-green-800 border-l-4 border-green-500',
      error: 'bg-red-100 text-red-800 border-l-4 border-red-500',
      warning: 'bg-yellow-100 text-yellow-800 border-l-4 border-yellow-500',
      info: 'bg-blue-100 text-blue-800 border-l-4 border-blue-500',
    };

    return `${baseClasses} ${typeClasses[toast.type]}`;
  }

  // Icône à afficher selon le type de toast
  getIcon(toast: Toast): string {
    const icons = {
      success: 'check_circle',
      error: 'error',
      warning: 'warning',
      info: 'info',
    };

    return icons[toast.type];
  }

  // Supprime le toast
  closeToast(id: string): void {
    this.toastService.remove(id);
  }
}
